import React, { useEffect, useState } from "react";
import SigninButton from "./SigninButton/SigninButton";
import MenuCard from "./MenuCard/MenuCard";
import Tabs from "./Tabs/Tabs";
import AlphabetFilter from "./AlphabetFilter/AlphabetFilter";
import UserProfile from "./UserProfile/UserProfile";
import Logo from "../Logo/Logo";
import SearchBar from "../SearchBar/SearchBar";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "@asgardeo/auth-react";

const Header = ({
  showLogo = true,
  showSearch = true,
  showMenu = true,
  searchAnimation,
  showTab,
  showAlphabet,
  PlaceHolder,
  placeholderWords,
  enableSuggestions,
  enableFiltering,
  enableSearchTracking,
  SearchAsYouType,
}) => {
  const currentPage = useSelector((state) => state.home.currentPage);
  const navigate = useNavigate();
  const { state } = useAuthContext();
  const [hideLogoRow, setHideLogoRow] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const threshold = 60;
      const shouldHideLogoRow = scrollY > threshold;

      if (shouldHideLogoRow !== hideLogoRow) {
        setHideLogoRow(shouldHideLogoRow);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [hideLogoRow]);

  return (
    <div
      className={`${
        currentPage === "home"
          ? "bg-pl_bg_light_3 dark:bg-pl_bg_dark_1"
          : "bg-pl_bg_light_1 dark:bg-pl_bg_dark_3 border-y dark:border-pl_border_dark_1 border-pl_border_light_1 fixed"
      } w-full z-[100]`}
    >
      <div
        className={`flex flex-wrap items-center p-10 px-10 md:px-20 ${
          hideLogoRow && "md:flex-nowrap"
        }`}
      >
        {showLogo && (
          <div
            className={`${
              hideLogoRow ? "hidden md:flex" : "flex"
            } items-center flex-none pb-20 md:pb-0 `}
          >
            <button
              onClick={() => navigate("/")}
              className="flex items-center gap-2"
            >
              <Logo small />
            </button>
          </div>
        )}

        {showSearch && (
          <div className="flex-grow order-2 md:order-none w-full md:w-auto md:ml-10 relative">
            <div className="flex items-center">
              <SearchBar
                size="small"
                PlaceHolder={PlaceHolder}
                enableSuggestions={enableSuggestions}
                enableFiltering={enableFiltering}
                enableSearchTracking={enableSearchTracking}
                SearchAsYouType={SearchAsYouType}
                placeholderWords={placeholderWords}
                searchAnimation={searchAnimation}
                className="w-[70%] md:w-auto"
              />
            </div>
          </div>
        )}

        {showMenu && (
          <div
            className={`${
              hideLogoRow ? "hidden md:flex" : "flex"
            } gap-3 items-center ml-auto pb-20 md:pb-0 pl-10`}
          >
            <MenuCard />
            {state.isAuthenticated ? <UserProfile /> : <SigninButton />}
          </div>
        )}
      </div>

      {showTab && (
        <div
          className={`${
            hideLogoRow ? "hidden" : "block"
          } xl:ml-[220px] xl:w-[100vh-220px]`}
        >
          <Tabs />
        </div>
      )}

      {showAlphabet && isDesktop && (
        <div
          className={`${
            hideLogoRow ? "hidden" : "block"
          } xl:ml-[220px] xl:w-[100vh-220px]`}
        >
          <AlphabetFilter />
        </div>
      )}
    </div>
  );
};

export default Header;
